/*
 * "Llévalo en pack" (snippets/vk-packs-sugeridos.liquid).
 * - "Agregar pack": agrega por AJAX y re-renderiza el cart drawer / burbuja del tema (mismo flujo que app.js).
 *   Si algo falla, cae al submit normal del form (/cart/add).
 * - "+$X más": se recalcula cuando cambia la variante seleccionada del producto principal.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-vk-packs]');
  if (!root) return;

  var SECTIONS = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  /* ---------- dinero (formato de la tienda) ---------- */
  var moneyFormat = root.dataset.moneyFormat || '${{amount_no_decimals}}';
  function withDelimiters(n, decimals, thousands, decimal) {
    var parts = (n / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }
  function formatMoney(cents) {
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        default: return withDelimiters(cents, 0, ',', '.');
      }
    });
  }

  /* ---------- "+$X más" por variante ---------- */
  var variantPrices = {};
  try { variantPrices = JSON.parse(root.dataset.variantPrices || '{}'); } catch (e) {}

  function updateDiffs(price) {
    if (typeof price !== 'number' || isNaN(price)) return;
    var diffs = root.querySelectorAll('[data-pack-price]');
    for (var i = 0; i < diffs.length; i++) {
      var d = parseInt(diffs[i].dataset.packPrice, 10) - price;
      diffs[i].hidden = !(d > 0);
      if (d > 0) diffs[i].textContent = '+' + formatMoney(d) + ' más';
    }
  }

  function mainVariantInput() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].hasAttribute('data-vk-pack-form') || root.contains(forms[i])) continue;
      var input = forms[i].querySelector('[name="id"]');
      if (input) return input;
    }
    return null;
  }

  var idInput = mainVariantInput();
  function syncVariant() {
    if (!idInput) return;
    var p = variantPrices[idInput.value];
    if (p !== undefined) updateDiffs(Number(p));
  }
  if (idInput) {
    idInput.addEventListener('change', syncVariant);
    if ('MutationObserver' in window) {
      new MutationObserver(syncVariant).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .variations, [data-variant-picker]')) {
        window.setTimeout(syncVariant, 0);
      }
    });
  }

  /* ---------- Agregar pack (AJAX + cart drawer del tema) ---------- */
  function innerHTMLFrom(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function renderSections(state) {
    if (!state || !state.sections) return;
    SECTIONS.forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = state.sections[s.section];
      if (!host || !html) return;
      var target = host.querySelector(s.selector) || host;
      var inner = innerHTMLFrom(html, s.selector);
      if (inner !== null) target.innerHTML = inner;
      if (s.id === 'Cart-Drawer' && typeof host.removeProductEvent === 'function') host.removeProductEvent();
    });
    if (typeof window.Cart !== 'undefined') {
      try { new window.Cart().renderContents(state); } catch (e) {}
    }
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-vk-pack-form]');
    if (!form || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var body = new FormData(form);
    body.append('sections', SECTIONS.map(function (s) { return s.section; }).join(','));
    body.append('sections_url', window.location.pathname);

    fetch(form.action, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'cart error');
        renderSections(state);
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: state.items ? state.items[0] : state } }));
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });
})();
